// Implements DESIGN.md "Loading states" — skeletons match the shape of
// the content they replace; never bare "Loading…" text.
import { Card } from '@/components/ui/Card';
import { Skeleton } from '@/components/ui/Skeleton';

export function DashboardSkeleton() {
  return (
    <div className="max-w-5xl stagger space-y-7">
      <header className="flex items-end justify-between flex-wrap gap-3">
        <div className="space-y-2">
          <Skeleton className="h-9 w-48" />
          <Skeleton className="h-4 w-32" />
        </div>
        <Skeleton className="h-7 w-16 rounded-full" />
      </header>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Card>
          <Skeleton className="h-3 w-12 mb-3" />
          <div className="space-y-3">
            <Skeleton className="h-8 w-24" />
            <Skeleton className="h-4 w-full max-w-[260px]" />
          </div>
        </Card>
        <Card>
          <Skeleton className="h-3 w-28 mb-3" />
          <div className="space-y-3">
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-5/6" />
            <Skeleton className="h-4 w-2/3" />
          </div>
        </Card>
      </div>

      <Card>
        <Skeleton className="h-3 w-20 mb-4" />
        <div className="space-y-3">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-5/6" />
          <Skeleton className="h-4 w-4/5" />
        </div>
      </Card>
    </div>
  );
}
